import { VEC2, type Vector } from '../math/vector'

export const findSVGElement = (el: SVGGeometryElement) => {
  const findParent = (el: Element): SVGSVGElement => {
    if (el.tagName === 'svg') return el as SVGSVGElement
    if (!el.parentElement) return el as SVGSVGElement
    return findParent(el.parentElement)
  }

  const parent = findParent(el)

  if (parent.tagName !== 'svg') return null
  return parent
}

export const getPositionInSVG = (svg: SVGSVGElement, pos: Vector) => {
  let point = svg.createSVGPoint()
  point.x = pos.x
  point.y = pos.y
  const ctm = svg.getScreenCTM()
  if (!ctm) return point;
  point = point.matrixTransform(ctm.inverse())
  return point;
}

export const toSVGSpace = (svg: SVGSVGElement, pos: Vector) => {
  const p = getPositionInSVG(svg, pos);
  return VEC2(p.x, p.y);
}
